

import React, { useEffect } from 'react';
import { notification, Spin } from "antd";
import FeaturedCompaniesSection from '../../shared/FeaturedCompaniesSection';

import CompanyDetailSection from '../../shared/CompanyDetailSection';
import CustomerReviews from '../../shared/CustomerReviews';
import EnquireFormSection from '../../shared/EnquireFormSection';

const CharityDetails = (props) => {
  const { shareCompany, subscribe, likeCompanyType, followCompanyType, getFeaturedIndustries, getPeopleNeededForHelp, enquireQuery, getCustomerReviews, getCharity, match, history, user, charityDetails } = props;
  const { params } = match || {};
  const charityId = params && params.id ? Number(params.id) : null;
  const { charity, numberOfPeople, featuredCharities, customerReviews, loading } = charityDetails || {};
  const companyType = 'Charity';
  useEffect(() => {
    if (charityId) {
      getCustomerReviews();
      getPeopleNeededForHelp();
      getFeaturedIndustries(companyType);
      getCharity(charityId, user && user.id ? user.id : navigator.userAgent);
    } else {
      notification.error({
        message: 'GET CHARITY DETAILS',
        description: 'charityID is not valid'
      })
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <Spin spinning={loading}>
        <section className="school-details-banner gen-banner-2">
          <div className="container">
            <div className="banner-text">
              <h1 className="heading"> </h1>
              <p></p>
            </div>
          </div>
        </section>

        <CompanyDetailSection 
          data={charity}
          numberOfPeople={numberOfPeople}
          companyType={companyType} 
          subscribe={subscribe} 
          user={user}
          history={history}
          shareCompany={shareCompany}
          getIndustryDetails={getCharity}
          getCompanyTypeListings={getCharity}
          followCompanyType={followCompanyType}
          likeCompanyType={likeCompanyType}
        />
        <CustomerReviews data={customerReviews} loading={loading}/>
        <FeaturedCompaniesSection 
          data={featuredCharities}
          companyType={companyType}
        />
        <EnquireFormSection 
          enquireQuery={enquireQuery}
        />
      </Spin>
    </div>
  );
};

export default CharityDetails;
